<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="2" y1="18" x2="22" y2="18" stroke="#708496" stroke-width="2" stroke-linecap="round" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.6632 17C17.8792 16.5454 18 16.0368 18 15.5C18 13.567 16.433 12 14.5 12C12.567 12 11 13.567 11 15.5C11 16.0368 11.1208 16.5454 11.3368 17H9.20703C9.07217 16.5232 9 16.02 9 15.5C9 12.4624 11.4624 10 14.5 10C17.5376 10 20 12.4624 20 15.5C20 16.02 19.9278 16.5232 19.793 17H17.6632Z"
      fill="#708496"
    />
    <path
      d="M2.5 5.5C3.66667 5.5 6.1 6.2 6.5 9M10 5C8.5 5 6.60155 5.67571 6.10155 7.67571"
      stroke="#708496"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>
